import { useCallback, useEffect, useState } from 'react'

const useScroll = (checkCondition: (x: number, y: number) => boolean, rootElement?: Element | null): boolean => {
  const [condition, setCondition] = useState<boolean>(false)

  const onScroll = useCallback(() => {
    const x = rootElement ? rootElement.scrollLeft : window.pageXOffset
    const y = rootElement ? rootElement.scrollTop : window.pageYOffset

    setCondition(checkCondition(x, y))
  }, [checkCondition, rootElement])

  useEffect(() => {
    onScroll()
    window.addEventListener('scroll', onScroll, { capture: !!rootElement })
    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('scroll', onScroll, { capture: !!rootElement })
    }
  }, [onScroll, rootElement])

  return condition
}

export default useScroll
